import { useState} from 'react';
import { Slider, Button } from 'antd';
import { forwardRef } from 'react'
import { useContext } from 'react'
import { AIEditContext } from '../../AIEditContext';
import Utils from '@utils/utils';
import styles from './index.module.scss'
import Iconfont from '@utils/Iconfont';
import { AppContext } from '@utils/AppContext';


const FillLightBar = forwardRef((props, ref) => {
    const {
        adjustLightFlag,
        highDefult, setHighDefult,
        rangeDefult, setRangeDefult,
        initialized, AIEditLoading
    } = useContext(AIEditContext)


    const [preset, setPreset] = useState()

    const selectPreset = (index, style) => {
        // 需要登录
        const status = Utils.checkLoginStatus(() => selectPreset(index, style))
        if (!status) return

        setPreset(index)
        props.selectPreset(index, style)
    }

    const handleLightAuto = () => {
        // 需要登录
        const status = Utils.checkLoginStatus(() => handleLightAuto())
        if (!status) return

        selectPreset(0, 'random')
    }

    const handleLightManual = () => {
        // 需要登录
        const status = Utils.checkLoginStatus(() => handleLightManual())
        if (!status) return

        props.lightLoadModule("light_intensity", 50, 'click')
    }

    return (
        <div className={styles.FillLight}>
            <div className={`${styles.FillLightContent} ${!props.url && styles.disabled}`}>
                {
                    <div style={{ paddingRight: '5px' }}>
                        <div className={styles.magicEraseBar_btn}>
                            <div
                                onClick={handleLightAuto}
                                className={`${styles.magicEraseBar_btn_}`}>
                                <Iconfont className={styles.Icon} type='icon-autolight' />
                                <p>自动补光</p>
                            </div>
                            <div
                                onClick={handleLightManual}
                                className={`${styles.magicEraseBar_btn_}`}>
                                <Iconfont className={styles.Icon} type='icon-smearOutlined' />
                                <p>手动调整</p>
                            </div>
                        </div>

                        <p className={styles.small_title}>光源强度</p>
                        <Slider
                            min={10}
                            disabled={adjustLightFlag}
                            value={highDefult}
                            tooltip={{ formatter: null }}
                            onChange={setHighDefult}
                            onChangeComplete={(vale) =>
                                props.lightSettingChange(vale, 'high')}
                        />
                        <p className={styles.small_title}>光源范围</p>
                        <Slider
                            min={10}
                            disabled={adjustLightFlag}
                            value={rangeDefult}
                            tooltip={{ formatter: null }}
                            onChange={setRangeDefult}
                            onChangeComplete={(vale) =>
                                props.lightSettingChange(vale, 'range')}
                        />
                    </div>
                }

                <Button
                    type="primary"
                    loading={AIEditLoading}
                    disabled={!initialized}
                    className={styles.createBtn}
                    onClick={props.saveResult}>
                    应用改动
                </Button>
            </div>
        </div>
    )
})

export default FillLightBar;
